import { exec } from "@kakaopay-common/payweb-core";
import { INTERFACE } from "../../constants.mjs";
function setStorageItem(key, value) {
  const command = {
    command: INTERFACE.SET_STORAGE_ITEM,
    parameters: {
      key,
      value
    }
  };
  return exec(command);
}
export {
  setStorageItem
};
